import AppRouter from "./AppRouter";
import { NavBar } from "./components/NavBar";
import { Copyright } from "./components/Copyright";

import "./scss/App.scss";

function App() {
  return (
    <div className='App'>
      <NavBar />
      <AppRouter />
      <Copyright />
    </div>
  );
}

export default App;
